// componente che contiene tutti i metodi utilizzati per gestire i pannelli; queste funzioni sono richiamate esternamente
// dalle altre componenti che costituiscono tutto il blocco di gestione pannelli (ttssettings-edit e ttssettings-list)

import { Injectable } from '@angular/core';
import { Ttssettings } from './ttssettings.model';
import { Subject } from 'rxjs';

@Injectable()
export class TtssettingsService {
  private ttssettings: Ttssettings[] = [];
  ttssettingsChanged = new Subject<Ttssettings[]>();
  ttssettingsEditMode = new Subject<number>();

  constructor(
  ) { }

  ngOnInit() {
  }

  // metodo che restituisce tutti i pannelli memorizzati localmente
  getTtssettings() {
    return this.ttssettings;
  }

  // metodo richiamato all'inserimento di un nuovo pannello; viene identificata la posizione nella tabella dell'elemento da aggiungere
  setTtssettings(ttssettings: Ttssettings[]) {
    if (ttssettings !== null) {
      this.ttssettings = ttssettings;
      this.ttssettingsChanged.next(this.ttssettings.slice());
    }
  }

}
